import React from "react";

import { Link } from "react-router-dom";

export default function BlogCard(props) {
  return (
    <>
      <div className="col-md-6 col-xl-4">
        <div className="bds-blog-main">
          <figure className="bds-blog-image">
            <Link to={"/blogs/this-is-a-blog-slug"}>
              <a>
                <img
                  src={props.imgUrl}
                  alt="image description"
                  layout="responsive"
                  width={"100%"}
                  height="70%"

                  className="img-fluid"
                  sizes="100vh"
                />
              </a>
            </Link>
          </figure>
          <div className="bds-blogs-section">
            <ul className="bds-tags">
              {props.categories.map((cat, idx) => (
                <li key={idx}>
                  <h6>
                    <Link to="#">
                      <a>{cat}</a>
                    </Link>
                  </h6>
                </li>
              ))}
            </ul>
            <h4>
              <Link to={"/blogs/this-is-a-blog-slug"}>
                <a>{props.title}</a>
              </Link>
            </h4>
            <p>{props.detial}</p>
          </div>
        </div>
      </div>
    </>
  );
}
